import React from 'react';

import MemoryCardHeader from './Header';
import MemoryCardAssets from './Assets';
import MemoryCardContent from './Content';

import type { Asset } from '../../types/asset';

interface MemoryCardProps {
  variant: 'memory' | 'timeline' | 'sprk';
  type: string;
  title: string;
  dedicated_to: string;
  name: string;
  date: string;
  content: string;
  assets: string[];
  tags: number[];
  allow_comments: boolean;
  allow_reactions: boolean;
  files: Asset[];
};

const MemoryCard: React.FC<MemoryCardProps> = ({ ...props }) => {
  return (
    <wa-card className={`memory-card memory-card-${props.variant}`}>
      <MemoryCardHeader {...props} variant={props.variant} />
      <MemoryCardAssets {...props} variant={props.variant} />
      <MemoryCardContent {...props} />
    </wa-card>
  );
}

export default MemoryCard;
